export const PermissaoUsuarioEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_USUARIO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_USUARIO",
	VISUALIZAR_APENAS_PROPRIOS_TENANTS_USUARIO:
		"VISUALIZAR_APENAS_PROPRIOS_TENANTS_USUARIO",
	CRIAR: "CRIAR_USUARIO",
	EXCLUIR: "EXCLUIR_USUARIO",
};

export const PermissaoGrupoUsuarioEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_GRUPO_USUARIO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_GRUPO_USUARIO",
	VISUALIZAR_ABAIXO_HIERARQUIA: "VISUALIZAR_ABAIXO_HIERARQUIA_GRUPO_USUARIO",
	CRIAR: "CRIAR_GRUPO_USUARIO",
	EXCLUIR: "EXCLUIR_GRUPO_USUARIO",
};

export const PermissaoTenantEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_TENANT",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_TENANT",
	VISUALIZAR_APENAS_PROPRIOS: "VISUALIZAR_APENAS_PROPRIOS_TENANTS",
	CRIAR: "CRIAR_TENANT",
	EXCLUIR: "EXCLUIR_TENANT",
};

export const PermissaoCategoriaPermissaoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_CATEGORIA_PERMISSAO",
	VISUALIZAR: "VISUALIZAR_CATEGORIA_PERMISSAO",
	CRIAR: "CRIAR_CATEGORIA_PERMISSAO",
	EXCLUIR: "EXCLUIR_CATEGORIA_PERMISSAO",
};

export const PermissaoPermissaoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_PERMISSAO",
	VISUALIZAR: "VISUALIZAR_PERMISSAO",
	CRIAR: "CRIAR_PERMISSAO",
	EXCLUIR: "EXCLUIR_PERMISSAO",
};

export const PermissaoGrupoUsuarioPermissaoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_GRUPO_USUARIO_PERMISSAO",
	VISUALIZAR: "VISUALIZAR_GRUPO_USUARIO_PERMISSAO",
	CRIAR: "CRIAR_GRUPO_USUARIO_PERMISSAO",
	EXCLUIR: "EXCLUIR_GRUPO_USUARIO_PERMISSAO",
};

export const PermissaoRequisicaoRecuperacaoSenhaEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_REQUISICAO_RECUPERACAO_SENHA",
	VISUALIZAR: "VISUALIZAR_REQUISICAO_RECUPERACAO_SENHA",
	CRIAR: "CRIAR_REQUISICAO_RECUPERACAO_SENHA",
	EXCLUIR: "EXCLUIR_REQUISICAO_RECUPERACAO_SENHA",
};

export const PermissaoEmpresaVendedoraEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_EMPRESA_VENDEDORA",
	VISUALIZAR: "VISUALIZAR_EMPRESA_VENDEDORA",
	CRIAR: "CRIAR_EMPRESA_VENDEDORA",
	EXCLUIR: "EXCLUIR_EMPRESA_VENDEDORA",
};

export const PermissaoTipoVendaEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_TIPO_VENDA",
	VISUALIZAR: "VISUALIZAR_TIPO_VENDA",
	CRIAR: "CRIAR_TIPO_VENDA",
	EXCLUIR: "EXCLUIR_TIPO_VENDA",
};

export const PermissaoStatusAtivoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_STATUS_ATIVO",
	VISUALIZAR: "VISUALIZAR_STATUS_ATIVO",
	CRIAR: "CRIAR_STATUS_ATIVO",
	EXCLUIR: "EXCLUIR_STATUS_ATIVO",
};

export const PermissaoTipoInvestidorEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_TIPO_INVESTIDOR",
	VISUALIZAR: "VISUALIZAR_TIPO_INVESTIDOR",
	CRIAR: "CRIAR_TIPO_INVESTIDOR",
	EXCLUIR: "EXCLUIR_TIPO_INVESTIDOR",
};

export const PermissaoAtivoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_ATIVO",
	VISUALIZAR: "VISUALIZAR_ATIVO",
	CRIAR: "CRIAR_ATIVO",
	EXCLUIR: "EXCLUIR_ATIVO",
};

export const PermissaoInvestidorEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_INVESTIDOR",
	VISUALIZAR: "VISUALIZAR_INVESTIDOR",
	CRIAR: "CRIAR_INVESTIDOR",
	EXCLUIR: "EXCLUIR_INVESTIDOR",
};

export const PermissaoDistribuidoraEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_DISTRIBUIDORA",
	VISUALIZAR: "VISUALIZAR_DISTRIBUIDORA",
	CRIAR: "CRIAR_DISTRIBUIDORA",
	EXCLUIR: "EXCLUIR_DISTRIBUIDORA",
};

export const PermissaoComercializadorGeradorEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_COMERCIALIZADOR_GERADOR",
	VISUALIZAR: "VISUALIZAR_COMERCIALIZADOR_GERADOR",
	CRIAR: "CRIAR_COMERCIALIZADOR_GERADOR",
	EXCLUIR: "EXCLUIR_COMERCIALIZADOR_GERADOR",
};

export const PermissaoFaixaCepEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_FAIXA_CEP",
	VISUALIZAR: "VISUALIZAR_FAIXA_CEP",
	CRIAR: "CRIAR_FAIXA_CEP",
	EXCLUIR: "EXCLUIR_FAIXA_CEP",
};

export const PermissaoComercializadorEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_COMERCIALIZADOR",
	VISUALIZAR: "VISUALIZAR_COMERCIALIZADOR",
	CRIAR: "CRIAR_COMERCIALIZADOR",
	EXCLUIR: "EXCLUIR_COMERCIALIZADOR",
};

export const PermissaoParceiroEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_PARCEIRO",
	VISUALIZAR: "VISUALIZAR_PARCEIRO",
	CRIAR: "CRIAR_PARCEIRO",
	EXCLUIR: "EXCLUIR_PARCEIRO",
};

export const PermissaoStatusCepEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_STATUS_CEP",
	VISUALIZAR: "VISUALIZAR_STATUS_CEP",
	CRIAR: "CRIAR_STATUS_CEP",
	EXCLUIR: "EXCLUIR_STATUS_CEP",
};

export const PermissaoEnderecoUsinaEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_ENDERECO_USINA",
	VISUALIZAR: "VISUALIZAR_ENDERECO_USINA",
	CRIAR: "CRIAR_ENDERECO_USINA",
	EXCLUIR: "EXCLUIR_ENDERECO_USINA",
};

export const PermissaoStatusGeradorEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_STATUS_GERADOR",
	VISUALIZAR: "VISUALIZAR_STATUS_GERADOR",
	CRIAR: "CRIAR_STATUS_GERADOR",
	EXCLUIR: "EXCLUIR_STATUS_GERADOR",
};

export const PermissaoTipoGeradorEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_TIPO_GERADOR",
	VISUALIZAR: "VISUALIZAR_TIPO_GERADOR",
	CRIAR: "CRIAR_TIPO_GERADOR",
	EXCLUIR: "EXCLUIR_TIPO_GERADOR",
};

export const PermissaoStatusPropostaEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_STATUS_PROPOSTA",
	VISUALIZAR: "VISUALIZAR_STATUS_PROPOSTA",
	CRIAR: "CRIAR_STATUS_PROPOSTA",
	EXCLUIR: "EXCLUIR_STATUS_PROPOSTA",
};

export const PermissaoContaEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_CONTA",
	VISUALIZAR: "VISUALIZAR_CONTA",
	CRIAR: "CRIAR_CONTA",
	EXCLUIR: "EXCLUIR_CONTA",
};

export const PermissaoEnderecoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_ENDERECO",
	VISUALIZAR: "VISUALIZAR_ENDERECO",
	CRIAR: "CRIAR_ENDERECO",
	EXCLUIR: "EXCLUIR_ENDERECO",
};

export const PermissaoConsumidorEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_CONSUMIDOR",
	VISUALIZAR: "VISUALIZAR_CONSUMIDOR",
	CRIAR: "CRIAR_CONSUMIDOR",
	EXCLUIR: "EXCLUIR_CONSUMIDOR",
};

export const PermissaoPropostaEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_PROPOSTA",
	VISUALIZAR: "VISUALIZAR_PROPOSTA",
	CRIAR: "CRIAR_PROPOSTA",
	EXCLUIR: "EXCLUIR_PROPOSTA",
};

export const PermissaoGeradorEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_GERADOR",
	VISUALIZAR: "VISUALIZAR_GERADOR",
	CRIAR: "CRIAR_GERADOR",
	EXCLUIR: "EXCLUIR_GERADOR",
};

export const PermissaoContratoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_CONTRATO",
	VISUALIZAR: "VISUALIZAR_CONTRATO",
	CRIAR: "CRIAR_CONTRATO",
	EXCLUIR: "EXCLUIR_CONTRATO",
};
